import _slicedToArray from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "bsPrefix", "className"],
    _excluded2 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useBootstrapBreakpoints, useBootstrapMinBreakpoint } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function useCol(_ref) {
  var as = _ref.as,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  var breakpoints = useBootstrapBreakpoints();
  var minBreakpoint = useBootstrapMinBreakpoint();
  var spans = [];
  var classes = [];
  breakpoints.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      span = propValue.span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
    if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
    if (order != null) classes.push("order".concat(infix, "-").concat(order));
    if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
  });
  return [_objectSpread(_objectSpread({}, props), {}, {
    className: classNames.apply(void 0, [className].concat(spans, classes))
  }), {
    as: as,
    bsPrefix: bsPrefix,
    spans: spans
  }];
}
var Col = /*#__PURE__*/React.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (props, ref) {
  var _useCol = useCol(props),
      _useCol2 = _slicedToArray(_useCol, 2),
      _useCol2$ = _useCol2[0],
      className = _useCol2$.className,
      colProps = _objectWithoutProperties(_useCol2$, _excluded2),
      _useCol2$2 = _useCol2[1],
      _useCol2$2$as = _useCol2$2.as,
      Component = _useCol2$2$as === void 0 ? 'div' : _useCol2$2$as,
      bsPrefix = _useCol2$2.bsPrefix,
      spans = _useCol2$2.spans;

  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, colProps), {}, {
    ref: ref,
    className: classNames(className, !spans.length && bsPrefix)
  }));
});
Col.displayName = 'Col';
export default Col;